<template>
  <div  class="home" style="overflow: hidden;" v-if="userInformations">
    <!-- <loading-overlay class="no-print" :text="'Lade Daten...'" v-if="updating && !fullscreen" /> -->

    
      
    <b-row class="m-0 justify-content-center" style="padding-top: 80px; padding-bottom: 250px" v-show="!fullscreen">

      <div style="width: 1700px; max-width: 90%">
        <div class="image-preview py-3" v-if="company">
          <b-row class="m-0 justify-content-between">
          <div v-if="company.img">
            <img class="preview rounded" alt="new" style="max-height: 100px" :src="getImage(company.img.image)">
          </div>
          <b-button class="linear-info text-white border" size="sm" style="height: 40px; font-size: 15px" @click="$router.push('/kiosk').catch(err => {})">Kioskmodus starten <b-icon class="ml-2" :icon="!fullscreen ? 'arrows-fullscreen' : 'fullscreen-exit'" variant="white"></b-icon></b-button>
          </b-row>
        </div>
        <b-row class="m-0 mt-5 justify-content-center" v-if="!userInformations.initDone">

          <b-col cols="12" style="w-100" class="p-0">
            <div  class="showcase-invert bg-white shadow m-2"  style="min-width: 95%" >
              <div class="showcase-header py-4 linear-warning text-dark" style="position: relative;">
                <h4 class="text-center m-0">Willkommen</h4>
              </div>

              <!-- Init Wizard -->
              <init-wizard :init="true"></init-wizard>
              <!-- Init Wizard -->
              
              <b-row class="m-0 my-3 justify-content-center">
                <div>
                  <b-row class="m-0 my-3 justify-content-center">
                    <b-img  :src="require(`@/assets/images/undraw_Setup_wizard.svg`)" style="width: 200px;" fluid alt="eatDorado Logo"></b-img>
                  </b-row>
                </div>
              </b-row>
            </div>
          </b-col>

        </b-row>

    <b-row class="m-0 mt-2 justify-content-center" v-if="userInformations.initDone">

      <b-col cols="12" style="w-100" class="p-0">
        <message-center class="mb-4"/>
      </b-col>

      <b-col cols="12" style="w-100" class="p-0">
        <div  class="showcase-invert bg-white shadow mx-2 mb-2"  style="min-width: 95%" >
          <div class="showcase-header py-4 linear-primary text-white" style="position: relative; cursor: pointer" @click="$router.push('/orders').catch(err => {})">
            <h4 class="text-center m-0">Offene Bestellungen <span v-if="orders">({{orders.filter(order => order.status != 'abgeholt' && order.status != 'storniert').length}})</span></h4>
          </div>
          <div v-if="orders">
            <b-table @row-clicked="setOrder" borderless :fields="fields" :items="orders.filter(el => el.status != 'abgeholt' && el.status != 'storniert')" striped responsive :per-page="10"
                :current-page="currentPageOrders">
        
            <template v-slot:head()="data">
              <p class="text-center text-dark" >{{ data.label.toUpperCase() }}</p>
            </template>

            <template v-slot:cell(created)="data">
              <p class="text-center my-2 text-dark" >{{data.item.created | moment('DD.MM.YYYY HH:mm')}}</p>
            </template>

            <template v-slot:cell(delivery_time)="data">
              <p class="text-center my-2 text-dark" >{{data.item.delivery_time | moment('DD.MM.YYYY HH:mm')}}</p>
            </template>

            <template v-slot:cell(customer_firstname)="data">
              <p class="text-center my-2 text-dark" >{{data.item.customer_firstname + ' ' + data.item.customer_lastname}}</p>
            </template>

            <template v-slot:cell(status)="data">
              <p class="text-center my-2 text-dark" ><b-badge :variant="getBadgeVariant(data.item.status)">{{data.item.status}}</b-badge></p>
            </template>

            <template v-slot:cell(payment_method)="data">
              <p class="text-center my-2 text-dark" >{{data.item.payment_method}}</p>
            </template>

            <template v-slot:cell(ordernumber)="data">
              <p class="text-center my-2 text-dark" >{{data.item.ordernumber}}</p>
            </template>

            <template v-slot:cell(price)="data">
              <p class="text-center my-2 text-dark" >{{ getTotalPrice(data.item) }}</p>
            </template>

             <template v-slot:cell(customer_verified)="data">
              <p class="m-0 text-center">
                <b-icon v-if="data.item.customer_verified" class="text-success h1 m-0 p-0" icon="check" aria-hidden="true"></b-icon>
                <b-icon v-if="data.item.customer_verified === false" class="text-danger h1 m-0 p-0" icon="x" aria-hidden="true"></b-icon>
              </p>
            </template>
          
          </b-table>
          <nav class="mt-4" v-if="orders.filter(el => el.status != 'abgeholt').length > 10">
            <b-pagination size="sm" :total-rows="orders.filter(el => el.status != 'abgeholt').length" :per-page="10" v-model="currentPageOrders" prev-text="letzte" next-text="nächste" hide-goto-end-buttons/>
          </nav>

            <b-button variant="info" @click="finishOrders()" v-if="this.orders.filter(el => el.status == 'bereit').length > 0">Alle abgeholten Bestellungen abschließen</b-button>
          </div>
          <div v-if="orders">
          <b-row v-if="orders.length == 0" class="m-0 my-3 justify-content-center">
            <div>
              <b-row class="m-0 my-3 justify-content-center">
                <b-img  :src="require(`@/assets/images/undraw_completed.svg`)" style="width: 200px; height: 200px" fluid alt="eatDorado Logo"></b-img>
              </b-row>
              <h3 class="text-center">Keine Bestellungen offen</h3>
            </div>
          </b-row>
          </div>
        </div>
        
      </b-col>

      <b-col cols="12" md="6" lg="6" xl="6" style="w-100" class="p-0" v-if="company">
        <div  class="showcase-invert bg-white shadow m-2 mt-4"  style=" min-width: 95%" >
          <div class="showcase-header py-4 linear-info text-white" style="position: relative">
            <h4 class="text-center m-0">Bewertungen ({{company.ratings.length}})</h4>
          </div>
          <div v-if="company.ratings">
            <b-row class="m-0 my-3 justify-content-center" v-if="company.ratings.length == 0">
              <div>
                <b-row class="m-0 my-3 justify-content-center">
                  <b-img  :src="require(`@/assets/images/undraw_void.svg`)" style="width: 160px; height: 200px" fluid alt="eatDorado Logo"></b-img>
                </b-row>
                <h3 class="text-center">Keine Bewertungen vorhanden</h3>
              </div>
            </b-row>
            <div class="bg-white" style="border-radius: 10px; transition: all .5s;  overflow-y: auto" :style="company.ratings.length > 0 ? 'height: 300px;' : ''">
              <div class="m-3" v-for="rating in company.ratings" :key="rating.index">
                <b-row class="m-0 justify-content-between">
                  <small>{{ rating.sender }}</small>
                  <small v-if="rating.date">{{ rating.date | moment('DD.MM.YY HH:mm')}}</small>
                </b-row>
                <div class="my-2 p-2 bg-light rounded" v-if="rating.text">
                  <small>Nachricht:</small>
                  <div>
                    {{ rating.text }}
                  </div>
                </div>

                <div class="bg-light p-2 rounded" v-if="rating.hint">
                  <small>Hinweis/Kritik:</small>
                  <div>
                    {{ rating.hint }}
                  </div>
                </div>

                <b-form-rating readonly class="mb-3 text-center" size="md" :no-border="true" variant="warning" v-model="rating.rating"></b-form-rating>
                
                <hr>
              </div>
            </div>
          </div>
          
        </div>
      </b-col>

      <b-col cols="12" md="6" lg="6" xl="6" style="w-100" class="p-0">
        <div  class="showcase-invert bg-white shadow m-2 mt-4"  style="min-width: 95%" >
          <div class="showcase-header py-4 linear-success text-white" style="position: relative; cursor: pointer" @click="$router.push('/statistics').catch(err => {})">
            <h4 class="text-center m-0">Umsatz {{new Date()|moment('MMMM')}} 2020</h4>
          </div>
          <b-row class="m-0 my-3 justify-content-center">
            <div>
              <b-row class="m-0 my-3 justify-content-center">
                <b-img  :src="require(`@/assets/images/undraw_empty.svg`)" style="width: 200px; height: 200px" fluid alt="eatDorado Logo"></b-img>
              </b-row>
              <h3 class="text-center">{{ getTotalMonth(new Date().getMonth() + 1) }}</h3>
            </div>
          </b-row>
        </div>
      </b-col>
    
    </b-row>
      </div>

    </b-row>

    <!-- <fullscreen class="bg-white" ref="fullscreen" @change="fullscreenChange" v-show="fullscreen">
      <b-row class="m-0 justify-content-center w-100 h-100 bg-white" >
        <div style="width: 1700px; max-width: 100%">
          <div>
            <b-row class="justify-content-between mx-2 mt-3" v-if="orders">
              <h1 style="font-size: 80px">{{ timestamp }}</h1>
              <div v-if="orders.filter(el => el.status == 'bestellt')">
              <h3 class="m-0 mt-4 text-danger" v-if="orders.filter(el => el.status == 'bestellt').length > 0">Offene Bestellungen: {{ orders.filter(el => el.status == 'bestellt').length }}</h3>

              </div>
              <b-button class="mt-4 linear-info text-white border" size="sm" style="height: 40px; font-size: 15px" @click="toggle"> <font-awesome-icon style="font-size: 30px; cursor: pointer" :icon="['fas', 'times']"/></b-button>
            </b-row>
            <b-row class="m-0 justify-content-start">

              <b-col cols="4" style="w-100" class="p-1" v-for="(slotplace) in slots" :key="slotplace.index">
                <div  class="showcase-invert bg-white shadow mb-2 mt-4" style="width: 100%" v-if="company">

                  <div class="showcase-header text-white" :class="getHeaderVariant(slotplace)" style="position: relative; cursor: pointer">
                    <h1 class="text-center m-0">{{slotplace.time}}</h1>
                  </div>
                  <div v-if="company.orderSlots">
                    <div v-if="company.orderSlots.find(slot => slot.time == slotplace.time && slot.date == timeString) && checkOpeningTimes(slotplace.time)">
                      <div class="p-3 card bg-light mb-3" v-for="slot in company.orderSlots.find(slot => slot.time == slotplace.time && slot.date == timeString).orders" :key="slot.index">
                        <div v-if="findOrder(slot._id)">
                          <b-row class="m-0 justify-content-between">
    
                            <h5 class="m-0">Telefon: </h5>
                            <h5 class="m-0">{{findOrder(slot._id).customer_phone}}:</h5>
                          </b-row>
                          <b-row class="m-0 mb-3 justify-content-between">
                            <h5 class="m-0">Besteller: </h5>
                            <h5 class="m-0">{{findOrder(slot._id).customer_firstname}} {{findOrder(slot._id).customer_lastname}}</h5>
                          </b-row>
                          <div>
                            <hr>
                            <div class="my-2" v-for="item in findOrder(slot._id).items" :key="item.index">
                              <b-row class="m-0 justify-content-between" >
                                <h5 class="m-0">{{ item._id.title }}</h5>
                                <h5 class="m-0">x {{ item.amount }}</h5>
                              </b-row>
                              <b-row class="m-0 justify-content-between" v-if="item.note">
                                <p class="m-0">Hinweis: {{ item.note }}</p>
                              </b-row>
                              <b-row class="m-0 mt-1 justify-content-between" v-if="item.extras">
                                <div v-for="extra in item.extras" class="w-100" :key="extra.index">
                                  <p v-if="extra.choosen" class="m-0">{{ extra.title }}</p>
                                </div>
                              </b-row>
                              <hr>
                            </div>
                            
                          </div>
                          
                          <b-row class="m-0 mt-3 justify-content-between">
                            <h4 class="m-0">Rechnungsbetrag:</h4>
                          <h4 class="m-0">{{getTotalPrice(findOrder(slot._id))}}</h4> 
                        </b-row>
                        <b-row class="m-0 mt-3 justify-content-between">
                          <b-button block variant="warning" v-if="findOrder(slot._id).status == 'bestellt'" @click="updateOrder(findOrder(slot._id), 'bestätigt')">Bestellung bestätigen</b-button>
                          <b-button block variant="info" v-if="findOrder(slot._id).status == 'bestätigt'" @click="updateOrder(findOrder(slot._id), 'bereit')">Bestellung ist abholbereit</b-button>
                          <b-button block variant="success" v-if="findOrder(slot._id).status == 'bereit'" @click="updateOrder(findOrder(slot._id), 'abgeholt')">Bestellung wurde abgeholt</b-button>
                          <b-button block variant="success" disabled v-if="findOrder(slot._id).status == 'abgeholt'" >Bestellung ist abgeschlossen!</b-button>
                        </b-row>
                      </div>
                      <div v-if="slot.blocked_manual">
                        <b-row class="m-0 justify-content-center">
                          <b-button disabled variant="danger">Bestellung vor Ort reserviert</b-button>
                        </b-row>
                      </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="company.orderSlots">
                    <div v-if="company.orderSlots.find(slot => slot.time == slotplace.time && slot.date == timeString)">
                      <div class="p-3 card bg-light mb-3" v-for="a in company.amount_slots - company.orderSlots.find(slot => slot.time == slotplace.time && slot.date == timeString).orders.length" :key="a.index">
                        <b-row class="m-0 justify-content-center">
                          <b-button variant="danger" @click="blockOrderSlot(slotplace.time)">Bestellung reservieren</b-button>
                        </b-row>
                      </div>
                    </div>
                    <div v-else>
                      <div class="p-3 card bg-light mb-3" v-for="a in company.amount_slots" :key="a.index">
                        <b-row class="m-0 justify-content-center">
                          <b-button variant="danger" @click="blockOrderSlot(slotplace.time)">Bestellung reservieren</b-button>
                        </b-row>
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <div v-for="a in company.amount_slots" :key="a.index">
                      <b-row class="m-0 justify-content-center">
                        <b-button variant="danger" @click="blockOrderSlot(slotplace.time)">Bestellung reservieren</b-button>
                      </b-row>
                      <hr>
                    </div>
                  </div>
                  
                </div>
              </b-col>

            </b-row>
          </div>
        </div>
      </b-row>
    </fullscreen> -->
    
  </div>
</template>

<script>
// import LoadingOverlay from '@/shared/animations/loadingOverlay'
import coreData from '@/mixins/coreDataMixin'
import axiosAuth from '@/shared/configs/axios-auth'
import InitWizard from '@/views/components/InitWizard'

export default {
  name: 'Home',
  mixins: [coreData],
  components: {
    // LoadingOverlay,
    InitWizard
  }, 
  data: () => {
    return {
      currentPageOrders: 1,
      error: null,
      actualTime: null,
      sortDesc: false, 
      sortBy: 'delivery_time',
      interval: null,
      intervalPeriodic: null,
      timestamp: "",
      loadingWizard: false,
         errorMsg: null,
         count: 0,
      imageData: "",
      file1: null,
      countriesSelect: [{ text: 'auswählen...', value: null }, 'Deutschland', 'Österreich', 'Schweiz'],
      form: {},
      restaurant: {
        adress: {},
        contact: {}
      },
      fields: [
        { key: 'created', label: 'Bestellzeit' },
        { key: 'delivery_time', label: 'Abhol-/Lieferzeit'},
        { key: 'customer_firstname', label: 'Kunde' },
        { key: 'price', label: 'Preis' },

        { key: 'ordernumber', label: 'Bestellnummer' },
        { key: 'status', label: 'Status' },
        { key: 'customer_verified', label: 'Bestätigt' },
      ],
      plus: null
    }
  },
  computed: {

    timeString(){
      var newDate = new Date()
      return newDate.getFullYear()+ '-' + ("0" + (newDate.getMonth()+1)).slice(-2) + '-' + ("0" + newDate.getDate()).slice(-2)
    },

    nextTimes(){

      var times = {
        time1: {
          date: null,
          time: null
        }
      }
      var today = new Date()

      if(this.actualTime){
        today = this.actualTime;
      }
      today.setMinutes(today.getMinutes() - 30);
      today.setMinutes(today.getMinutes());
      if(this.selectedDate){
        today = new Date(this.selectedDate+'T' + ("0" + today.getHours()).slice(-2) + ':' + ("0" + (today.getMinutes())).slice(-2) +':00')
      }
            
      var m = (((today.getMinutes() + 7.5)/15 | 0) * 15) % 60;
      var h = ((((today.getMinutes()/105) + .5) | 0) + today.getHours()) % 24;
      
      var timestring =  today.getFullYear()+ '-' + ("0" + (today.getMonth()+1)).slice(-2) + '-' + ("0" + today.getDate()).slice(-2) + 'T' + ("0" + h).slice(-2) + ':' + ("0" + m).slice(-2) +':00'
      var rounded = new Date(timestring);

      var m1 = (parseInt((rounded.getMinutes() + 7.5)/15) * 15) % 60;

      times.time1.time = ("0" + (rounded.getHours())).slice(-2) +':'+ ("0" + m1).slice(-2)
      times.time1.date = rounded

      return times
    },
  },
  mounted(){

  this.refreshData();

  try {
      this.intervalPeriodic = setInterval( this.refreshPeriodic, 30000);
    } catch (error) {
      console.log(error)
    }

    if(this.company){
      this.$store.dispatch('checkSlots', {company: this.company._id, date: this.timeString})
    }
    
    this.$store.dispatch('getOrders')
    this.getNow()
    this.interval = setInterval(this.getNow, 1000);
  },
  beforeDestroy(){
    clearInterval(this.interval)
    clearInterval(this.intervalPeriodic)
  },
  watch:{
    company(){
      if(this.company){
        this.restaurant = this.company
        this.$store.dispatch('checkSlots', {company: this.company._id, date: this.timeString})
      }
    },
  },
  methods: {
    setOrder(record){
      this.$router.push('/orders?id='+record._id).catch(() => {})
    },

    finishOrders(){
      var array = this.orders.filter(el => el.status == 'bereit')
      array.forEach(element => {
        var payload = {
        _id: element._id,
          data: {
            status: 'abgeholt'
          }
        }
        this.$store.dispatch('updateOrder', payload)
      })
    },
    getHeaderVariant(slotplace){
      if(!this.orders) return
      var test = this.orders.find(slot => slot.time == slotplace.time && slot.date == this.timeString)
      var variant = 'linear-primary'
      if(test){
        if(test.status == 'bestellt') {
          variant = 'linear-danger'
        }
      }
      return variant
    },
    refreshPeriodic(){

      this.$store.dispatch('getOrders')
      this.$store.dispatch('checkSlots', {company: this.company._id, date: this.timeString})
      this.$store.dispatch('getCompany')
    },
    getDateFromTime(time){
      var date = new Date(this.timeString+'T'+time)
      return date
    },
    blockOrderSlot(time){
      var date = this.timeString
      var payload = {
        data: {
          date: date,
          time: time
        }
      }
      this.$store.dispatch('blockOrderSlot', payload)
    },
    updateOrder(order, status){
      if(!order.customer_verified) return

      const payload = {
        _id: order._id,
        data: {
          status: status
        }
      }
      this.$store.dispatch('updateOrder', payload)
    },
    findOrder(id){
      var orders = this.orders.find(order => order._id == id)
      if(orders) return orders
      return null
    },
    getNextTime(minutes){
      var date = new Date(this.nextTimes.time1.date.getTime() + minutes*60000);
      var payload = {
        date: date,
        time: ("0" + (date.getHours())).slice(-2)+':'+("0" + (date.getMinutes())).slice(-2)
      }
      return payload
    },
    getNextTime2(minutes, time){
      var today = new Date(this.timeString+'T'+time+':00')
      var date = new Date(today.getTime() + minutes*60000);
      var payload = {
        date: date,
        time: ("0" + (date.getHours())).slice(-2)+':'+("0" + (date.getMinutes())).slice(-2)
      }
      return payload
    },
    getNow: function() {
        const today = new Date();
        this.actualTime = new Date();
        const time = ("0" + today.getHours()).slice(-2) +':'+ ("0" + today.getMinutes()).slice(-2)
        const dateTime = time;
        this.timestamp = dateTime;
    },
    toggle () {
      this.$store.commit('showUi', !this.showUi)
      this.$store.commit('fullscreen', !this.fullscreen)
    },
    fullscreenChange (fullscreen) {
      this.fullscreen = fullscreen
    },
    getTotalMonth(month){
      var total = 0.0
      if(!this.orders) return total
      this.orders.filter(order => order.status == 'abgeholt' || order.status == 'bestätigt').forEach(element => {
        if(month == new Date(element.delivery_time).getMonth() + 1){
          // element.items.forEach(item => {
          //   total += item.amount * item._id.price
          // })
           total += parseInt(this.getTotalPrice(element))
        }
      });
      return total.toFixed(2) + '€'
    },
        onComplete: function(){
          try {
            axiosAuth.patch('/users/me', {initDone: true})
            .then(
                () => {
                  this.userInformations.initDone = true
                }
              )
            .catch(
                error => {
                  alert('NOPE. DOPE');
                    console.log(error.response)

                }
            ) 
            
          } catch (error) {
            console.log(error)
          }
           
        },
        setLoading: function(value) {
            this.loadingWizard = value
        },
        handleValidation: function(isValid, tabIndex){
           console.log('Tab: '+tabIndex+ ' valid: '+isValid)
        },
        handleErrorMessage: function(errorMsg){
          console.log(errorMsg)
          this.errorMsg = errorMsg
        },
        validateAsyncStep1:function() {
          return new Promise((resolve, reject) => {

              if(!this.userInformations.firstname || !this.userInformations.lastname || !this.userInformations.contact.phone || !this.userInformations.adress.street || !this.userInformations.adress.zipcode || !this.userInformations.adress.city || !this.userInformations.adress.country){
                reject('Es wurden nicht alle Felder ausgefüllt!')
              }else{
                const payload = {
  
                  firstname: this.userInformations.firstname,
                  lastname: this.userInformations.lastname,
                  adress: {
                    street: this.userInformations.adress.street,
                    zipcode: this.userInformations.adress.zipcode,
                    city: this.userInformations.adress.city,
                    country: this.userInformations.adress.country,
                  },
                  contact:{
                    email: this.userInformations.email,
                    phone: this.userInformations.contact.phone
                  } 
                }
                try {
                  axiosAuth.patch('/users/me', payload)
                  .then(
                      () => {
                          resolve(true)
                      }
                    )
                  .catch(
                      error => {
                          console.log(error.response)
                          reject(error.response.data)
                      }
                  ) 
                  
                } catch (error) {
                  reject(error)
                }
                
                
              }

          })
         },
        
        validateAsyncStep2:function() {
          return new Promise((resolve, reject) => {

              if(!this.restaurant.title || !this.restaurant.description || !this.restaurant.contact.phone || !this.restaurant.contact.email || !this.restaurant.adress.street || !this.restaurant.adress.zipcode || !this.restaurant.adress.city || !this.restaurant.adress.country){
                reject('Es wurden nicht alle Felder ausgefüllt!')
              }else{
                if(!this.company){
                  axiosAuth.post('/companies', this.restaurant)
                    .then(
                        () => {
                            this.$store.dispatch('getCompany')
                            resolve(true)
                        }
                    )
                    .catch(
                    error => {
                      
                        console.log(error.response)
                        reject(error.response.data)
                    }
                  )
                }else{
                  
                  var payload = {
                    title: this.company.title,
                    description: this.company.description,
                    adress: {
                        city: this.company.adress.city,
                        street: this.company.adress.street,
                        zipcode: this.company.adress.zipcode,
                        country: this.company.adress.country
                    },
                    contact: {
                        email: this.company.contact.email,
                        phone: this.company.contact.phone
                    },
                  }

                  axiosAuth.patch('/companies/'+ this.company._id, payload)
                    .then(
                        () => {
                          this.$store.dispatch('getCompany')
                          resolve(true)
                        }
                      )
                    .catch(
                        error => {
                            console.log(error.response)
                        reject(error.response.data)
                        }
                    ) 
                }
                
              }

          })
         },

         validateAsyncStep3:function() {
          return new Promise((resolve, reject) => {

              if(!this.file1 && !this.company.img){
                reject('Es wurde kein Logo hochgeladen!')
              }else{
                
                if(this.imageData){
                  let formData = new FormData();

                    formData.append('company', this.company._id)
                    formData.append('image', this.file1);

                    axiosAuth.post('companies/upload', formData,)
                      .then(
                        () => {
                          this.$store.dispatch('getCompany')
                          resolve(true)
                        }
                      )
                    .catch(
                        error => {
                            console.log(error.response)
                        reject(error.response.data)
                        }
                    ) 
                }else{
                  resolve(true)
                }
                    

              }

          })
         },
  
    onSubmit(){

    },

    previewImage: function(event) {
        // Reference to the DOM input element
        var input = event.target;
        // Ensure that you have a file before attempting to read it
        if (input.files && input.files[0]) {
            // create a new FileReader to read this image and convert to base64 format
            var reader = new FileReader();
            // Define a callback function to run, when FileReader finishes its job
            reader.onload = (e) => {
                // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
                // Read image as base64 and set to imageData
                this.imageData = e.target.result;
            }
            // Start the reader job - read file as a data url (base64 format)
            reader.readAsDataURL(input.files[0]);
        }
    }
  }
}
</script>

<style lang="scss">

</style>